"use strict";

import {findIn, closest} from '@elements/dom-utils'


export function init() {
    //tried to replicate the behaviour from .on('evt', '.selectors'), not sure if it does the same ...
    document.querySelector('body').addEventListener('click', function (evt) {
        let target = evt.target;
        let goToLink = closest('.js-go-to-link, .isClickable', target);
        if (goToLink && !closest('a, button, input, select, textarea, label', target)) {
            let link = findIn('.js-go-to-link__link', goToLink);
            if (!link) {
                link = findIn('a', goToLink);
            }
            let href = link.getAttribute('href');

            if (window.getSelection().toString()) {
                // make links selectable - so do nothing if a selection was made
                evt.preventDefault();
                evt.stopImmediatePropagation();
            } else if (href) {
                if (link) {
                    try {
                        link.dispatchEvent(new MouseEvent(evt.originalEvent.type, evt.originalEvent));

                        // allow crtl + click on the whole .js-go-to-link element.
                        // this works only for some browsers (eg: Chrome, Edge)
                        // but does not break anything for others (eg: IE, Firefox)
                    } catch (e) { // IE 11 fallback
                        link.click();
                    }
                }

                evt.preventDefault();
                evt.stopImmediatePropagation();
            }
        }
    }, false);
}

